define('uikit/views/table.navigation',['require','exports','module','underscore','backbone','marionette','handlebars','../templates','../channel','../mixins/component.mixin','../collections/table'],function(require, exports, module){
  var _ = require('underscore');
  var Backbone = require('backbone');
  var Mn = require('marionette');
  var Handlebars = require('handlebars');
  var Templates = require('../templates');
  var channel = require('../channel');
  var ComponentMixin = require('../mixins/component.mixin');
  var Table = require('../collections/table');

  var TableNavigation = Mn.ItemView.extend(ComponentMixin).extend({

    template: Templates.UIKit['list.navigation'],

    options: {
      value: null,
      collection: null,
      waitForSync: false,
      animationIn: 'slide left',
      animationOut: 'slide right',
      table: null
    },

    tableOptions: {
      headless: true,
      selectable: true,
      selection: 'single'
    },

    attributes: {
      styles: 'position: relative'
    },

    ui: {
      'tableContainer': '.table-container'
    },

    initialize: function() {
      ComponentMixin.initialize.apply(this, arguments);
      this.tableOptions = _.extend({}, this.tableOptions, this.options.tableOptions);
      this.columns = new Backbone.Collection(this.getOption('columns') || [], { model: Table.ColumnModel });
    },

    onFirstRender: function() {
      this
          .on('change:collection', this._onCollectionChange, this)
          .on('change:table', this._onTableChange, this);

      this._onCollectionChange();
    },

    _onCollectionChange: function() {
      var collection   = this.collection,
          showingTable = !!this.table;

      if (!collection) { return; }

      this.table = new Table(_.extend({}, this.tableOptions, { collection: collection, value: this.value, visible: !showingTable }));
      this.table.columns = this.columns
    },

    _onTableChange: function(view, newTable, oldTable) {
      if (newTable) {
        this.setupNewTable(oldTable);
      } else if (oldTable) {
        this.destroyTable(oldTable);
      }
    },

    navigateImmediately: function(value) {
      this._immediateNavigate = true;
      this.value = value;
      return this;
    },

    navigateNext: function(value) {
      this.value = value;
      return this;
    },

    navigatePrevious: function(value) {
      this._previousNavigate = true;
      this.value = value;
      return this;
    },

    setupNewTable: function(oldTable) {
      var table = this.table,
          self  = this;

      table
          .listenTo(this, 'destroy', function() {
            table.destroy();
          })
          .listenTo(this, 'change:value', function() {
            table.value = self.value;
          })
          .on('change:value', function() {
            self.value = table.value;
          });

      table.render();
      table.triggerMethod('before:show');
      this.ui.tableContainer.append(table.$el);
      table.triggerMethod('show');

      if (!table.visible) {
        if (this._immediateNavigate) {
          this._immediateNavigate = false;
          table.visible = true;
          this.destroyTable(oldTable);
          return;
        }
        // wait until we get some children.....
        table.once(table.collection.isEmpty() ? 'render:empty' : 'add:child', _.debounce(function() {
          this.transitionTables(table, oldTable, function() {
            self.destroyTable(oldTable);
          });
        }), this);
      }
    },

    transitionTables: function(table, oldTable, done) {
      var self             = this,
          duration         = 400,
          $el              = this.$el,
          currentHeight    = this.$el.height(),
          previousNavigate = this._previousNavigate,
          newHeight        = 0,
          _done            = null;

      _done = _.after(3, function() {
        table.$el.css({
          position: '',
          top: '',
          left: ''
        });
        $el.get(0).style.height = '';
        if (done) { done() }
      });

      table.$el.removeClass('transition visible').css('display', '');
      oldTable.$el.removeClass('transition visible').css('display', 'none');
      newHeight = this.$el.height();
      $el.css({ height: currentHeight + 'px' })

      table.$el.css({
        position: 'absolute',
        top: '0px',
        left: '0px',
        marginTop: '0',
        height: table.$el.height() + 'px',
        display: 'none'
      });

      oldTable.$el.css({
        position: 'absolute',
        top: '0px',
        left: '0px',
        marginTop: '0',
        height: oldTable.$el.height() + 'px',
        display: ''
      });

      _.defer(function() {
        table.show({
          animation: previousNavigate ? self.animationOut : self.animationIn,
          duration: duration + 'ms',
          onComplete: _done
        });
        oldTable.hide({
          animation: previousNavigate  ? self.animationIn : self.animationOut,
          duration: duration + 'ms',
          onComplete: _done
        });
        $el.animate({ height: newHeight + 'px' }, { duration: duration, complete: _done });
      });
      this._previousNavigate = false;
    },

    destroyTable: function(table) {
      table.columns = new Backbone.Collection([]);
      table.destroy();
    }

  },
  {
    generateNestedIconColumn: function(field, icon) {
      icon = icon || 'angle right';
      field = field || 'children';
      return {
        data: true,
        align: 'right',
        formatter: function(value, model) {
          var collection = model.get(field);
          return !collection || collection.isEmpty() ? '' : new Handlebars.SafeString('<i class="icon ' + Handlebars.escapeExpression(icon) + '"></i>');
        }
      };
    }
  });

  channel.reply('table-navigation', function() {
    return TableNavigation;
  });

  module.exports = TableNavigation;
});
